export async function LoadShiplistData(userID) {
    try {
        const url = `/returnShiplists/${userID}`;

        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        
        return { data };
    } catch (error) {
        throw error;
    }
}